import { useContext } from "react";
import NeuralInterfaceContext from "./NeuralInterfaceContext";
const useModalWindowContext = () => useContext(NeuralInterfaceContext);
export default useModalWindowContext;
